exports = module.exports = require("../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.divider[data-v-03301c7e] {\n    font-size: 1rem;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n&[data-v-03301c7e]::before,\n    &[data-v-03301c7e]::after {\n        content: '';\n        display: block;\n        height: 0.09em;\n        min-width: 30vw;\n}\n&[data-v-03301c7e]::before {\n        background: #DDD;\n        margin-right: 4vh;\n}\n&[data-v-03301c7e]::after {\n        background: #DDD;\n        margin-left: 4vh;\n}\nimg[data-v-03301c7e] {\n        width: 3em;\n}\n}\n.legend[data-v-03301c7e] {\n    text-align: center;\n    padding: 1rem;\n    font-weight: 600;\n}\n", ""]);

// exports
